import { useState } from 'react';
import { LogOut, User, Coins, Plus } from 'lucide-react';
import { Link } from 'react-router';
import { useAuth, useLogout } from '@/features/auth/hooks';
import { useWallet } from '@/features/wallet/hooks/use-wallet';
import { FaucetModal } from '@/features/wallet/components/faucet-modal';
import { ThemeToggle } from '@/components/shared/theme-toggle';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export function Header() {
  const { user } = useAuth();
  const { balance } = useWallet();
  const logoutMutation = useLogout();
  const [faucetOpen, setFaucetOpen] = useState(false);
  return (
    <>
      <header className="sticky top-0 z-30 flex h-16 shrink-0 items-center justify-between gap-3 border-b bg-background/95 px-4 sm:px-6 lg:h-18 lg:px-8">
        <div className="w-10 lg:hidden" />
        <span className="hidden text-sm text-muted-foreground lg:block">
          Your next great call starts here.
        </span>
        <div className="ml-auto flex items-center gap-2 sm:gap-3">
          <Button
            variant="secondary"
            onClick={() => setFaucetOpen(true)}
            aria-label={`Wallet: ${balance.toLocaleString()} PRED. Claim free coins`}
          >
            <Coins className="text-muted-foreground" />
            <span className="font-mono">{balance.toLocaleString()}</span>
            <span className="hidden text-xs text-muted-foreground sm:inline">PRED</span>
            <Plus className="text-primary" />
          </Button>
          <ThemeToggle />
          {user && (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="secondary"
                  size="icon"
                  className="rounded-full bg-accent text-accent-foreground"
                  aria-label="User menu"
                >
                  {user.name.charAt(0).toUpperCase()}
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-60">
                <div className="mb-1 border-b px-3 py-3">
                  <p className="truncate text-sm font-semibold">{user.name}</p>
                  <p className="truncate text-xs text-muted-foreground">{user.email}</p>
                </div>
                <DropdownMenuItem asChild>
                  <Link to="/settings/profile">
                    <User />
                    Profile
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem
                  disabled={logoutMutation.isPending}
                  onSelect={() => logoutMutation.mutate()}
                  className="text-destructive"
                >
                  <LogOut />
                  {logoutMutation.isPending ? 'Logging out…' : 'Log out'}
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
      </header>
      <FaucetModal open={faucetOpen} onOpenChange={setFaucetOpen} />
    </>
  );
}
